import GIF from 'gif.js';
import { GifReader } from 'omggif';
import { IMAGE_WIDTH, IMAGE_HEIGHT, IMAGE_EXTENDED } from '../constants';
// import { RequestProxyUrl } from './imageUrl';

export async function extractFrames(gifFile) {
    const gifBlob = await fetchGifAsBlob(gifFile);

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const arrayBuffer = e.target.result;
                const uint8Array = new Uint8Array(arrayBuffer);
                const reader = new GifReader(uint8Array);
    
                const frames = [];
    
                for (let i = 0; i < reader.numFrames(); i++) {
                    const frameInfo = reader.frameInfo(i);
                    const pixels = new Uint8Array(reader.width * reader.height * 4);
                    reader.decodeAndBlitFrameRGBA(i, pixels);
    
                    // Log details about the frame
                    /*
                    console.log(`Frame ${i}:`, {
                        width: reader.width,
                        height: reader.height,
                        pixelsLength: pixels.length,
                        delay: frameInfo.delay * 10,
                    });
                    */
    
                    frames.push({
                        width: reader.width,
                        height: reader.height,
                        pixels: pixels,
                        delay: frameInfo.delay * 10,
                    });
                }
    
                resolve(frames);
            } catch (error) {
                reject(error);
            }
        };
  
        console.log(``);
        reader.readAsArrayBuffer(gifBlob);
    });
}

export async function overlayFrames(frames, overlayImage, layerType) {   
    const framesPromises = frames.map(frame => overlaySingleFrame(frame, overlayImage, layerType));
    const processedFrames = await Promise.all(framesPromises);

    // console.log(`PROCESSED FRAMES[0]:- WIDTH: ${processedFrames[0].width} - HEIGHT: ${processedFrames[0].height}`);

    return processedFrames;
}

export async function createAnimatedGif(overlayedFrames, delay, layerType) { 
    let gifWidth = 0;
    let gifHeight = IMAGE_HEIGHT;
    if (layerType === 0 || layerType === 2) {
        gifWidth = IMAGE_EXTENDED;
    } else {
        gifWidth = IMAGE_WIDTH;
    }

    const gif = new GIF({
        workerScript: process.env.PUBLIC_URL + '/gif.worker.js',
        workers: 2,
        quality: 10, // This is a value between 1 and 10, where 10 is the highest quality and 1 is the fastest speed.
        width: gifWidth,
        height: gifHeight
    });

    overlayedFrames.forEach(frame => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = gifWidth;
        canvas.height = gifHeight; 

        // console.log(`FRAME PIXELS CHECK:- PIXELS LENGTH: ${frame.pixels.length} - EXPECTED: ${gifWidth * gifHeight * 4}`);

        const imageData = new ImageData(new Uint8ClampedArray(frame.pixels), gifWidth, gifHeight);
        ctx.putImageData(imageData, 0, 0);
        gif.addFrame(ctx, {delay: delay});

        // console.log(`gif frame added... width: ${gifWidth}, height: ${gifHeight}`);
    });

    return new Promise((resolve, reject) => {
        gif.on('finished', function (blob) {
            console.log(`Animated gif creation complete.`);
            resolve(URL.createObjectURL(blob));
        });

        gif.on('error', function (error) {
            console.error("Error while generating GIF:", error);
            reject(error);
        });

        gif.render();
    });
}

export async function convertPathToImage(imagePath, layerType) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous"; // set the crossorigin attribute
       
        const gifWidth = layerType === 0 ? IMAGE_EXTENDED : IMAGE_WIDTH;
        img.onload = () => {
            // Clear the event handlers
            img.onload = null;
            img.onerror = null;

            const canvas = document.createElement('canvas');
            canvas.width = gifWidth;
            canvas.height = IMAGE_HEIGHT;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, gifWidth, IMAGE_HEIGHT);
            resolve(canvas.toDataURL());
        };

        img.onerror = (errorEvent) => {
            // Clear the event handlers
            img.onload = null;
            img.onerror = null;
            
            reject(new Error(`Failed to load and resize image at path: ${imagePath}. Reason: ${errorEvent.message}`));
        };

        img.src = imagePath;
    });
}

//===============================
// internal utility functions
//===============================
async function fetchGifAsBlob(gifPath) {
    const response = await fetch(gifPath);
    return await response.blob();
}

async function overlaySingleFrame(frame, overlay, layerType) {
    const { width, height, pixels, delay } = frame;
    let newImageData = null;
    let newWidth = width;
    let newHeight = height;

    // console.log(`*** DEBUG [OVERLAYSINGLEFRAME]: LAYERTYPE: ${layerType} | WIDTH: ${width}`);    

    // check the frame dimensions - they should be fine but just in case
    if (layerType === 0 && width !== IMAGE_EXTENDED) {  
        // console.log(`*** DEBUG: layerType === 0 && width !== IMAGE_EXTENDED`);

        // background gif sizes should be the IMAGE_EXTENDED size
        newImageData = await resizePixelData(pixels, width, height, IMAGE_EXTENDED, IMAGE_HEIGHT); 
        newWidth = IMAGE_EXTENDED;
        newHeight = IMAGE_HEIGHT;        
    } else if (layerType === 1 && width !== IMAGE_WIDTH) {
        // console.log(`*** DEBUG: layerType === 1 && width !== IMAGE_WIDTH`);

        // frontend gif sizes should be the IMAGE_WIDTH size
        newImageData = await resizePixelData(pixels, width, height, IMAGE_WIDTH, IMAGE_HEIGHT);
        newWidth = IMAGE_WIDTH;
        newHeight = IMAGE_HEIGHT;
    } else if (layerType === 2) {
        console.log(`*** DEBUG: layerType === 2`);

        newImageData = new ImageData(new Uint8ClampedArray(pixels), width, height);

        // frontend gif but overlayed on a wide background
        //newImageData = await resizePixelData(pixels, width, height, IMAGE_EXTENDED, IMAGE_HEIGHT); 
        newWidth = IMAGE_EXTENDED;
        newHeight = IMAGE_HEIGHT; 
    }
    else {
        // console.log(`*** DEBUG: ELSE`);

        newImageData = new ImageData(new Uint8ClampedArray(pixels), width, height);
    }

    // create and load the frame image onto an 'offscreen' canvas
    const offscreenCanvas = document.createElement('canvas');
    offscreenCanvas.width = newWidth;
    offscreenCanvas.height = newHeight;
    const offscreenCtx = offscreenCanvas.getContext('2d');

    //const imageData = new ImageData(new Uint8ClampedArray(pixels), newWidth, newHeight);
    offscreenCtx.putImageData(newImageData, 0, 0);

    // create the main canvas object
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Set the canvas dimensions
    canvas.width = newWidth;
    canvas.height = newHeight;
    ctx.clearRect(0, 0, newWidth, newHeight);    
    

    if (layerType === 0) {
        ctx.drawImage(offscreenCanvas, 0, 0, newWidth, newHeight);    
        ctx.drawImage(overlay, 0, 0, overlay.width, overlay.height);
    } else if (layerType === 1) {
        ctx.drawImage(overlay, 0, 0, overlay.width, overlay.height);         
        ctx.drawImage(offscreenCanvas, 0, 0, newWidth, newHeight);    
    } else if(layerType === 2) {
        ctx.drawImage(overlay, 0, 0, overlay.width, overlay.height);         
        ctx.drawImage(offscreenCanvas, 0, 0, newWidth, newHeight);  
    }

    // Get the modified pixels from the canvas
    const modifiedPixels = ctx.getImageData(0, 0, newWidth, newHeight).data;

    return { newWidth, newHeight, pixels: modifiedPixels, delay };
}

async function resizePixelData(pixels, srcWidth, srcHeight, targetWidth, targetHeight) {
    const srcCanvas = document.createElement('canvas');
    srcCanvas.width = srcWidth;
    srcCanvas.height = srcHeight;
    const srcCtx = srcCanvas.getContext('2d');
    const imageData = new ImageData(new Uint8ClampedArray(pixels), srcWidth, srcHeight);
    srcCtx.putImageData(imageData, 0, 0);

    const targetCanvas = document.createElement('canvas');
    targetCanvas.width = targetWidth;
    targetCanvas.height = targetHeight;
    const targetCtx = targetCanvas.getContext('2d');
    targetCtx.drawImage(srcCanvas, 0, 0, targetWidth, targetHeight);

    const resizedImageData = targetCtx.getImageData(0, 0, targetWidth, targetHeight).data;

    return new ImageData(resizedImageData, targetWidth, targetHeight);
}

